import { actionsFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { GetAdminOrganizationStatisticsParamsType, OrganizationStatisticsEntity } from './types';

export const getAdminOrganizationStatistics = actionsFactories.createGetOneActionsFactory<
  EntityType<OrganizationStatisticsEntity>,
  GetAdminOrganizationStatisticsParamsType
>()(
  'GET_ADMIN_ORGANIZATION_STATISTICS_REQUEST',
  'GET_ADMIN_ORGANIZATION_STATISTICS_SUCCESS',
  'GET_ADMIN_ORGANIZATION_STATISTICS_FAILURE',
  'GET_ADMIN_ORGANIZATION_STATISTICS_RESET',
);
